<template>
  <div v-loading="allPageLoading" :class="$style.payList">
    <div v-if="!installmentTableVisible" style="padding:20px 16px" :class="[$style['header']]">
      <el-page-header v-if="paymentType !== 'installment' && !assignAmountVisible" @back="backFunc"></el-page-header>
      <div v-else style="height: 50px;"></div>
    </div>
    <div :class="$style['payList__paymentAll']">
      <!-- 訂單總計 -->
      <div v-if="paymentType === 'fullPayment' || installmentTableVisible" :class="$style['payList__orderTotal']">
        <p v-if="!unpaidChildrenOrderTotal" class="colorSecondary f16 mb4">
          訂單總計
          <span class="colorPrimary f16">NT$ {{ oldAndNewOrderComputed }}</span>
        </p>
        <p v-else class="colorSecondary f16 mb4">
          訂單總計
          <span class="colorPrimary f16">NT$ {{ unpaidChildrenOrderTotal }}</span>
        </p>
        <p class="colorTextLight">{{ paymentMethodName['title'] }}</p>
      </div>
      <!-- 單次付款／分期付款選擇畫面 -->
      <div v-if="guestCheck === false && paymentStatus.length === 0 && paymentType === ''" :class="$style['payList__paymentList']" class="mt-5">
        <p class="text-center mb-5 colorSecondary">選擇付款方式</p>
        <div :class="$style['payList__paymentList__upper']">
          <div @click="paymentTypeFunc('fullPayment')">
            <div :class="$style['payList__paymentList__iconBorder']">
              <BaseIcon name="money-bill-wave-alt" icon-style="fal" />
            </div>
            <p class="colorSecondary f16 mb8">單次付款</p>
            <p class="colorTextLight">一次付清所有金額</p>
          </div>
          <div @click="paymentTypeFunc('installment')">
            <div :class="$style['payList__paymentList__iconBorder']">
              <BaseIcon name="puzzle" icon-style="fal" />
            </div>
            <p class="colorSecondary f16 mb8">分期付款</p>
            <p class="colorTextLight">分期支付金額</p>
          </div>
        </div>
      </div>
      <!-- 線下付款/線上付款/儲值點數抵扣 選擇畫面 -->
      <div v-if="paymentStatus.length === 0 && paymentType === 'fullPayment'" :class="$style['payList__paymentList']">
        <div :class="$style['payList__paymentList__upper']">
          <div :style="{ width: $cashFlowSettingPass() ? '300px' : '620px' }" @click="paymentFunc('offLine')">
            <div :class="$style['payList__paymentList__iconBorder']">
              <BaseIcon name="money-bill-wave-alt" icon-style="fal" />
            </div>
            <p class="colorSecondary f16 mb8">線下付款</p>
            <p class="colorTextLight">現場信用卡、線下匯款、現金付款</p>
          </div>
          <div v-if="$cashFlowSettingPass()" @click="paymentFunc('onLine')">
            <div :class="$style['payList__paymentList__iconBorder']">
              <BaseIcon name="credit-card-alt" icon-style="fat" />
            </div>
            <p class="colorSecondary f16 mb8">線上付款</p>
            <p class="colorTextLight">線上信用卡、虛擬帳戶</p>
          </div>
        </div>

        <div v-if="$hasDeposit()" :class="$style['payList__paymentList__lower']" @click="paymentFunc('deposit')">
          <div :class="$style['payList__paymentList__lower__icon']">
            <BaseIcon name="dollar-sign" icon-style="fal" />
          </div>
          <p class="colorSecondary f16 mb8">儲值點數抵扣</p>
          <p class="colorTextLight"
            >點數餘額：<span class="colorPrimary">{{ depositReduce }}點</span></p
          >
        </div>
      </div>
      <!-- 線下付款選擇付款方式畫面 -->
      <div v-if="paymentStatus === 'offLine' && paymentMethodOnView === ''" :class="$style['payList__offLine']">
        <div :class="$style['payList__offLine__upper']">
          <div @click="paymentMethodFunc('StoreCredit')">
            <div :class="$style['payList__offLine__iconBorder']">
              <svg class="fillFull" height="42.869" viewBox="0 0 57.262 42.869" width="57.262" xmlns="http://www.w3.org/2000/svg">
                <g fill="#ea6a2a" stroke="#fff" transform="translate(-7.25 -11.5)">
                  <path
                    d="m14.728 53.869h34.891a6.978 6.978 0 0 0 6.981-6.978h.436a6.978 6.978 0 0 0 6.978-6.978v-20.935a6.978 6.978 0 0 0 -6.981-6.978h-34.89a6.978 6.978 0 0 0 -6.978 6.978h-.436a6.978 6.978 0 0 0 -6.979 6.978v20.935a6.978 6.978 0 0 0 6.978 6.978zm38.38-20.935h-41.869v-3.489h41.869zm-30.965-17.445h34.89a3.489 3.489 0 0 1 3.489 3.489v20.935a3.489 3.489 0 0 1 -3.489 3.487h-.433v-17.444a6.978 6.978 0 0 0 -6.978-6.978h-30.969a3.489 3.489 0 0 1 3.49-3.489zm-7.414 6.978h34.89a3.489 3.489 0 0 1 3.489 3.489h-41.869a3.489 3.489 0 0 1 3.489-3.489zm38.38 13.956v10.468a3.489 3.489 0 0 1 -3.489 3.489h-34.892a3.489 3.489 0 0 1 -3.489-3.489v-10.467z"
                  />
                  <path d="m25.245 32.489h10.467a1.745 1.745 0 0 0 0-3.489h-10.467a1.745 1.745 0 0 0 0 3.489z" transform="translate(11.727 12.657)" />
                </g>
              </svg>
            </div>
            <p class="colorSecondary f16 mb8">現場信用卡</p>
          </div>
          <div @click="paymentMethodFunc('Atm')">
            <div :class="$style['payList__offLine__iconBorder']">
              <svg class="fillFull" height="52" viewBox="0 0 52 52" width="52" xmlns="http://www.w3.org/2000/svg">
                <path d="m1 1h50v50h-50z" fill="none" stroke="#ea6a2a" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                <g fill="#ea6a2a" stroke="#fff">
                  <path
                    d="m120.81 115.852a1.153 1.153 0 0 1 .042-.234l3.961-13c.235-.746 1.194-1.108 2.173-1.108s1.94.362 2.175 1.108l3.985 13a1.15 1.15 0 0 1 .042.234c0 .79-1.214 1.366-2.131 1.366-.533 0-.956-.171-1.093-.619l-.724-2.664h-4.489l-.724 2.664c-.128.448-.555.619-1.093.619-.91-.001-2.124-.576-2.124-1.366zm7.736-4.475-1.556-5.711-1.556 5.711z"
                    transform="translate(-113.158 -95.657)"
                  />
                  <path
                    d="m213.707 102.45c.7 0 1 .766 1 1.47 0 .81-.363 1.514-1 1.514h-2.94v11.572c0 .683-.832 1.023-1.662 1.023s-1.663-.34-1.663-1.023v-11.573h-2.942c-.639 0-1-.7-1-1.514 0-.7.3-1.47 1-1.47z"
                    transform="translate(-184.553 -96.469)"
                  />
                  <path
                    d="m302.731 112.508a1.221 1.221 0 0 1 -1.108.619 1.093 1.093 0 0 1 -1.044-.619l-2.025-3.707v8.2c0 .683-.832 1.023-1.662 1.023s-1.662-.34-1.662-1.023v-12.889a1.538 1.538 0 0 1 1.662-1.662c1.193 0 1.7.127 2.578 1.662l2.2 3.836 2.2-3.836c.874-1.535 1.385-1.662 2.579-1.662a1.529 1.529 0 0 1 1.663 1.662v12.893c0 .683-.832 1.023-1.663 1.023s-1.662-.34-1.662-1.023v-7.991z"
                    transform="translate(-263.752 -96.469)"
                  />
                </g>
                <path d="m6.944 30.372h19.124" fill="none" stroke="#ea6a2a" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                <path
                  d="m139.6 281h12.977v11.01a1.557 1.557 0 0 1 -1.557 1.557h-9.867a1.557 1.557 0 0 1 -1.557-1.557v-11.01z"
                  fill="none"
                  stroke="#ea6a2a"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  transform="translate(-129.382 -250.628)"
                />
              </svg>
            </div>
            <p class="colorSecondary f16 mb8">線下匯款</p>
          </div>
        </div>
        <div :class="$style['payList__offLine__upper']">
          <div @click="paymentMethodFunc('Cash')">
            <div :class="$style['payList__offLine__iconBorder']">
              <svg class="strokeFull" height="50" viewBox="0 0 50 50" width="50" xmlns="http://www.w3.org/2000/svg">
                <g fill="none">
                  <g stroke="#e86a35" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2">
                    <ellipse cx="35" cy="6" rx="14" ry="5" />
                    <path d="m21 7v6c0 2.761 6.266 5 14 5s14-2.239 14-5v-6" />
                    <path d="m28.55 24.439a35.748 35.748 0 0 0 6.45.561c7.734 0 14-2.239 14-5v-6" />
                    <path d="m21 14v4.27" />
                    <path d="m29.025 31.523a36.2 36.2 0 0 0 5.975.477c7.734 0 14-2.238 14-5v-6" />
                    <path d="m28.948 38.51a36.136 36.136 0 0 0 6.052.49c7.734 0 14-2.238 14-5v-6" />
                    <ellipse cx="15" cy="23" rx="14" ry="5" />
                    <path d="m1 24v6c0 2.762 6.266 5 14 5s14-2.238 14-5v-6" />
                    <path d="m1 31v6c0 2.762 6.266 5 14 5s14-2.238 14-5v-6" />
                    <path d="m1 38v6c0 2.762 6.266 5 14 5s14-2.238 14-5v-6" />
                  </g>
                </g>
              </svg>
            </div>
            <p class="colorSecondary f16 mb8">現金付款</p>
          </div>
          <div @click="paymentMethodFunc('none')">
            <div :class="$style['payList__offLine__iconBorder']">
              <BaseIcon name="question" />
            </div>
            <p class="colorSecondary f16 mb8">不指定付款方式</p>
          </div>
        </div>
        <div :class="$style['payList__offLine__upper']">
          <div :style="{ width: hasChailease ? '300px' : '620px' }" @click="paymentMethodFunc('StoreLinePay')">
            <div :class="$style['payList__offLine__iconBorder']">
              <img src="@assets/images/icons/line-pay.png" alt="Line Pay" />
            </div>
            <p class="colorSecondary f16 mb8">Line Pay</p>
          </div>
          <div v-if="hasChailease" @click="paymentMethodFunc('Chailease')">
            <div :class="$style['payList__offLine__iconBorder']">
              <img src="@assets/images/icons/chailease.png" alt="中租零卡分期" />
            </div>
            <p class="colorSecondary f16 mb8">中租零卡分期</p>
          </div>
        </div>
      </div>
      <!-- 線上付款選擇付款方式畫面 -->
      <div v-if="paymentStatus === 'onLine' && paymentMethodOnView === ''" :class="$style['payList__onLine']">
        <div :class="$style['payList__onLine__upper']">
          <div @click="paymentMethodFunc('Credit')">
            <div :class="$style['payList__onLine__iconBorder']">
              <svg class="strokeFull" height="56.299" viewBox="0 0 56.213 56.299" width="56.213" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" stroke="#e86a35" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" transform="translate(.5 .5)">
                  <path d="m17.026 54.8h-11.804a4.722 4.722 0 0 1 -4.722-4.722v-44.856a4.722 4.722 0 0 1 4.722-4.722h23.608a4.722 4.722 0 0 1 4.722 4.722v21.247" />
                  <path d="m33.713 9.713h-33" />
                  <path d="m17.713 45.713h-17" />
                  <path d="m11.713 5.713h10" />
                  <path d="m21.713 37.713h33" />
                  <path d="m35.713 43.713h-9" />
                  <path d="m49.713 43.713h-4" />
                  <path d="m31.713 46.713h-5" />
                  <rect height="23" rx="2" width="33" x="21.713" y="31.713" />
                  <path d="m6.109 18.279a3.284 3.284 0 1 0 3.284-3.284 3.284 3.284 0 1 1 3.284-3.284" transform="translate(7.633 10.787)" />
                  <path d="m17.026 32.352v2.186" />
                  <path d="m17.026 17.026v2.191" />
                </g>
              </svg>
            </div>
            <p class="colorSecondary f16 mb8">線上信用卡</p>
          </div>
          <div @click="paymentMethodFunc('Vacc')">
            <div :class="$style['payList__onLine__iconBorder']">
              <svg height="59.819" viewBox="0 0 59.819 59.819" width="59.819" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m27.939 0v2.941a4.411 4.411 0 0 0 0 8.823h2.941a1.47 1.47 0 1 1 0 2.941h-7.352v2.941h4.411v2.941h2.941v-2.941a4.411 4.411 0 1 0 0-8.823h-2.941a1.47 1.47 0 0 1 0-2.941h7.352v-2.941h-4.411v-2.941zm-7.352 11.54-20.587 6.496v8.432h2.941v23.532h-2.941v8.823h58.819v-8.823h-2.941v-23.531h2.941v-8.433l-20.587-6.5v3.079l17.646 5.585v3.332h-52.937v-3.342l17.646-5.572zm-14.705 14.929h2.941v23.531h-2.941zm5.882 0h5.882v23.531h-5.882zm8.823 0h2.941v23.531h-2.941zm5.882 0h5.882v23.531h-5.882zm8.823 0h2.941v23.531h-2.941zm5.882 0h5.882v23.531h-5.882zm8.823 0h2.941v23.531h-2.938zm-47.056 26.468h52.937v2.941h-52.937z"
                  fill="#ea6a2a"
                  stroke="#fff"
                  transform="translate(.5 .5)"
                />
              </svg>
            </div>
            <p class="colorSecondary f16 mb8">虛擬帳戶</p>
          </div>
        </div>
      </div>
      <!-- 線下付款選擇畫面 -> 細節 -->
      <div v-if="paymentStatus === 'offLine' && paymentMethodOnView !== ''">
        <div :class="$style.paymentMethodClass">
          <el-form ref="form" :model="submitData" :rules="submitRules">
            <!-- 信用卡 -->
            <el-form-item v-if="paymentMethodOnView === 'StoreCredit'" prop="Card4No" class="el-form-item--white-bg-border" :label="paymentMethodName['label']">
              <div class="el-form-item el-form-item--white-bg-border">
                <el-input v-model="submitData.Card4No" placeholder="請輸入" maxlength="4"> </el-input>
              </div>
            </el-form-item>
            <!-- ATM -->
            <el-form-item v-if="paymentMethodOnView === 'Atm'" prop="PayerAccount5Code" class="el-form-item--white-bg-border" :label="paymentMethodName['label']">
              <div class="el-form-item el-form-item--white-bg-border">
                <el-input v-model="submitData.PayerAccount5Code" placeholder="請輸入" maxlength="5"> </el-input>
              </div>
            </el-form-item>
            <!-- 現金 -->
            <el-form-item v-if="paymentMethodOnView === 'Cash'" class="el-form-item--white-bg-border" :label="paymentMethodName['label']"> </el-form-item>
            <!-- line pay -->
            <el-form-item v-if="paymentMethodOnView === 'StoreLinePay'" class="el-form-item--white-bg-border" :label="paymentMethodName['label']"> </el-form-item>
            <!-- 中租 -->
            <el-form-item v-if="paymentMethodOnView === 'Chailease'" class="el-form-item--white-bg-border" :label="paymentMethodName['label']"> </el-form-item>
          </el-form>
          <el-button type="primary" class="is-round is-fullwidth mt-3" :loading="saveLoading" :disabled="btnDisabled" @click="onClickSubmit('PAID')"> {{ paymentMethodName['btnCheck'] }}</el-button>
          <el-button
            v-if="paymentMethodOnView !== 'none' && paymentMethodOnView !== 'StoreLinePay' && paymentMethodOnView !== 'Chailease'"
            class="is-round is-fullwidth"
            :loading="saveLoading"
            :disabled="btnDisabled"
            @click="onClickSubmit('UNPAID')"
          >
            {{ paymentMethodName['btnPass'] }}
          </el-button>
          <el-button
            v-if="paymentMethodOnView === 'none' || paymentMethodOnView === 'StoreLinePay' || paymentMethodOnView === 'Chailease'"
            class="is-round is-fullwidth"
            :loading="saveLoading"
            @click="paymentMethodFunc('')"
          >
            回上一步
          </el-button>
        </div>
      </div>
      <!-- 線上付款選擇畫面 -> 細節 -->
      <div v-if="paymentStatus === 'onLine' && paymentMethodOnView !== ''">
        <div :class="$style.paymentOnLineMethodClass">
          <el-form ref="form" :model="submitData" :rules="submitRules">
            <!-- 虛擬帳戶 -->
            <el-form-item v-if="paymentMethodOnView === 'Vacc'" prop="Vacc" class="el-form-item--white-bg-border" :label="paymentMethodName['label']">
              <div class="el-form-item el-form-item--white-bg-border">
                <el-select v-model="submitData.bankType" class="is-round is-border">
                  <el-option v-for="(bank, index) in bankTypeList" :key="`bank-${index}`" :value="bank.id" :label="bank.title"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-form>
          <el-button type="primary" class="is-round is-fullwidth mt-3" :loading="saveLoading" @click="onClickSubmit('UNPAID')"> {{ paymentMethodName['btnCheck'] }} </el-button>
          <el-button class="is-round is-fullwidth" :loading="saveLoading" @click="onClickCancel">
            {{ paymentMethodName['btnPass'] }}
          </el-button>
        </div>
      </div>

      <!-- 儲值點數抵扣未開放 -->
      <el-dialog :visible.sync="depositDialog" width="550px" top="0" title="儲值點數抵扣未開放" :close-on-click-modal="false" append-to-body @closed="depositDialog = false">
        <div :class="$style.dialogText">
          <p>此方案未設定可使用儲值點數抵扣，請問是否確定抵扣 {{ oldAndNewOrderComputed }} 點？</p>
        </div>
        <el-button class="is-round is-fullwidth" type="primary" @click="methodDepositWindow"> 是 </el-button>
        <el-button class="is-round is-fullwidth" @click="depositDialog = false"> 否 </el-button>
      </el-dialog>

      <!-- 點數餘額不足 -->
      <el-dialog :visible.sync="depositNotOkDialog" width="550px" top="0" title="點數餘額不足" :close-on-click-modal="false" append-to-body @closed="depositDialog = false">
        <div :class="$style.dialogText">
          <p>點數餘額不足，是否立即儲值</p>
        </div>
        <el-button class="is-round is-fullwidth" type="primary" @click="tryToSaveOrder"> 是 </el-button>
        <el-button class="is-round is-fullwidth" @click="closeDepositNotOk"> 否 </el-button>
      </el-dialog>
      <!-- 預約已建立 -->
      <el-dialog :visible.sync="orderCheck" width="550px" top="0" :close-on-click-modal="false" append-to-body @closed="orderCheck = false">
        <div :class="$style.dialogCheckOk">
          <BaseIcon name="circle-check" icon-style="fas" />
          <p class="colorSecondary">預約已建立</p>
        </div>
      </el-dialog>

      <!-- 分期付款選單 -->
      <div v-if="paymentType === 'installment' && !installmentTableVisible" :class="$style['payList__installment']">
        <h5 class="text-center mb-5 colorSecondary">分期付款</h5>
        <el-form :model="installmentForm" :class="$style['payList__installment__form']">
          <p class="mb-4 fw-medium"
            >總付款金額：<span class="text-primary fw-regular">NT${{ installmentForm.total }}</span></p
          >
          <p v-if="assignAmountVisible" class="mb-4 fw-medium" :class="{ 'text-danger': installmentUnpaid, 'text-success': !installmentUnpaid }">剩餘未分配金額：NT${{ installmentUnpaid }}</p>
          <div class="pb-4 mb-4" :class="$style['payList__installment__times']">
            <span class="fs-sm">分期付款期數</span>
            <span v-if="assignAmountVisible" class="fs-sm">{{ installmentForm.installments }}期</span>
            <div v-if="!assignAmountVisible" class="d-flex align-items-center">
              <el-input v-model="installmentForm.installments" type="number" class="mr-3 no-number" @input="handleInput(null, $event)"></el-input>期
            </div>
          </div>
          <div v-if="assignAmountVisible" class="mb-4" :class="$style['payList__installment__amount']">
            <el-row v-for="time in parseInt(installmentForm.installments)" :key="time" :gutter="10" type="flex" align="middle" class="mb-4">
              <el-col :span="8">{{ `第${time}期付款金額：` }}</el-col>
              <el-col :span="14">
                <el-input v-model="installmentForm.installmentAmount[time - 1]" type="number" placeholder="請輸入金額" @input="handleInput(time - 1, $event)"></el-input>
              </el-col>
              <el-col :span="1">元</el-col>
            </el-row>
          </div>
          <div class="mb-3">
            <el-button v-if="!assignAmountVisible" type="primary" round class="w-100" @click="installmentStatusManage('assign')">下一步</el-button>
            <el-button v-else type="primary" round class="w-100" :disabled="installmentUnpaid !== 0" :loading="saveLoading" @click="installmentStatusManage('store')">前往付款</el-button>
          </div>
          <div>
            <el-button round class="w-100" :loading="saveLoading" @click="installmentStatusManage('back')">回上一步</el-button>
          </div>
        </el-form>
      </div>
      <!-- 單期付款頁面 -->
      <InstallmentPaymentTable v-if="installmentTableVisible" :installment-order="installmentOrder" @close="closeDialogAndDrawer"></InstallmentPaymentTable>
    </div>
  </div>
</template>

<script>
import lazyLoadComponent from '@router/lazyload-component'
import reserveOrder from '@src/mixins/reserveOrder'
import { bankTypeList } from '@utils/filter-value-to-text'
import { debounce } from 'lodash'
export default {
  name: 'PayList',
  components: {
    InstallmentPaymentTable: () => lazyLoadComponent(import('@components/Orders/components/InstallmentPaymentTable')),
  },
  mixins: [reserveOrder],
  props: {
    propsLoading: {
      type: Boolean,
      default: false,
    },
    /**
     * @description 使用者選到的服務的資料
     */
    newOrderInfo: {
      type: Object,
      default: () => {
        return {
          canPayByDeposit: true,
        }
      },
    },
    childOrderContainerId: {
      type: Object,
      default: () => {},
    },
    /**
     * @description 這個container的服務們
     */
    containerOrders: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * @description parent Container orderContainerUUid
     */
    orderContainerUuid: {
      type: String,
      default: '',
    },
    /**
     * @description 是否有新訂單
     */
    haveNewOrder: {
      type: Number,
      required: true,
    },
    /**
     * @description 付款人資訊
     */
    payPersonInfo: {
      type: Object,
      required: true,
    },
    /**
     * @description 新訂單的加總價錢
     */
    submitPriceTotal: {
      type: Number,
      default: 0,
    },
    /**
     * @description 會員資訊（包含containerId
     */
    memberInfo: {
      type: Object,
      required: true,
    },
    storeInvoiceSetting: {
      type: Number,
      default: -1,
    },
    guestCheck: {
      type: Boolean,
      default: false,
    },
    shippingInfo: {
      type: Object,
      default: () => ({}),
    },
    orderPaying: {
      type: Boolean,
      default: false,
    },
    isPrepaid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      afterPay: false, // 此訂單可先報到後付款
      paymentStatus: '', // 線下付款 or 線上付款 or 儲值點數抵扣
      paymentMethodOnView: '', // 信用卡 or 現金 or 匯款
      paymentMethodForSave: '', // 真正拿去打儲存的method
      submitData: {}, // 提交資料
      bankTypeList, // 銀行類別
      depositDialog: false, // 儲值點數抵扣視窗
      depositNotOkDialog: false, // 儲值點數餘額不足抵扣視窗
      orderCheck: false, // 預約已建立視窗畫面
      containerId: '', // booking的container ID
      saveLoading: false, // 儲存的loading
      btnCheckResolveFunc: () => {}, // 發票resolve func
      btnCheckRejectFunc: () => {}, // 發票reject func
      btnBillCheckSubmitData: {}, // 發票資訊
      allPageLoading: false,
      btnDisabled: false,
      paymentType: '',
      installmentForm: {
        total: 0,
        installments: 2,
        installmentAmount: [],
      },
      assignAmountVisible: false,
      installmentTableVisible: false,
      installmentOrder: {},
      installmentLoading: false,
    }
  },
  computed: {
    invoiceShow() {
      // 未有母容器 && 未有母容器id && 未有子容器id
      if (Object.keys(this.containerOrders).length === 0 && this.childOrderContainerId.parentUuid.length === 0 && this.childOrderContainerId.childUuid.length === 0 && this.storeInvoiceSetting === 1) {
        return true
      }
      // 父容器 未付款(已有容器 && 已有訂單)
      if (this.childOrderContainerId.parentUuid.length > 0 && this.childOrderContainerId.parentInvoiceStatus === 1) {
        return true
      }
      // 子容器 未付款(已有容器 && 已有訂單)
      if (this.childOrderContainerId.childUuid.length > 0 && this.childOrderContainerId.childInvoiceStatus === 1) {
        return true
      }
      return false
    },
    btnCheckNotShow() {
      const type = ['none']
      let show = true
      if (type.includes(this.paymentMethodForSave)) {
        show = false
      }
      return show
    },
    /**
     * @description 新+舊的order的總未付款價錢
     */
    oldAndNewOrderComputed() {
      if (this.haveNewOrder === 0) {
        // 如果沒新訂單，直接return 未付款金額
        return this.paidAndUnPaidSummary['unPaid']
      } else {
        // 有新訂單，要return 新訂單＋未付款金額
        return this.submitPriceTotal + this.paidAndUnPaidSummary['unPaid']
      }
    },
    /**
     * @description 儲值金餘額剩多少
     */
    depositReduce() {
      const { bonus, point } = this.memberInfo.depositInfo.solution2.reduceDepositTotal
      return bonus + point
    },
    /**
     * @description 計算未付款總額(舊有order)
     */
    computedSubmitPriceTotal() {
      try {
        let total = 0
        if (this.containerOrders.type === 'booking') {
          const { orders } = this.containerOrders
          // this.containerId = orders[0].orderContainerUuid
          total = orders.reduce((accumulator, currentValue) => {
            accumulator = accumulator + currentValue.unpaidTotal
            return accumulator
          }, 0)
        }
        return total
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 各線下匯款名稱
     */
    paymentMethodName() {
      const nameObj = {
        Cash: {
          title: '現金付款',
          label: '客人是否已付款',
          btnCheck: '是',
          btnPass: '否',
        },
        StoreCredit: {
          title: '現場信用卡',
          label: '請輸入信用卡末四碼',
          btnCheck: '確認',
          btnPass: '稍後付款',
        },
        Atm: {
          title: '線下匯款',
          label: '請輸入匯款帳號末五碼',
          btnCheck: '確認',
          btnPass: '稍後付款',
        },
        Vacc: {
          title: '虛擬帳戶',
          label: '轉帳銀行',
          btnCheck: '確認',
          btnPass: '取消',
        },
        Credit: {
          title: '線上信用卡',
          label: '線上信用卡',
          btnCheck: '確認',
          btnPass: '取消',
        },
        none: {
          title: '不指定付款方式',
          label: '不指定付款方式',
          btnCheck: '確認',
          btnPass: '確認',
        },
        StoreLinePay: {
          title: 'Line Pay',
          label: '是否確認付款',
          btnCheck: '確認',
          btnPass: '取消',
        },
        Chailease: {
          title: '中租零卡分期',
          label: '是否確認付款',
          btnCheck: '確認',
          btnPass: '取消',
        },
        installment: {
          title: '分期付款',
        },
      }
      if (this.paymentMethodOnView.length === 0) {
        return '選擇付款方式'
      } else {
        return nameObj[this.paymentMethodOnView]
      }
    },
    // 如果是訪客購買資訊自動帶入訪客資料
    guestPayInfo() {
      if (this.guestCheck) {
        return {
          fullName: this.memberInfo.fullName,
          gender: this.memberInfo.gender,
          phoneCode: this.memberInfo.phoneCode,
          phoneNumber: this.memberInfo.phoneNumber,
        }
      } else {
        return {}
      }
    },
    // 分期付款各期金額計算
    installmentUnpaid() {
      const paidNum = this.installmentForm.installmentAmount.reduce((acc, cur) => (parseInt(acc) || 0) + (parseInt(cur) || 0), 0)
      if (this.installmentForm.total - paidNum < 0) this.$message.error('超出總付款金額')
      return this.installmentForm.total - paidNum
    },
    childOrderPayment() {
      return this.childOrderContainerId?.childOrderId
    },
    // 中租付款只對特定商家開放
    hasChailease() {
      return this.$store.state.merchant.cached.alias === 'naturalpan'
    },
    unpaidChildrenOrderTotal() {
      if (Object.keys(this.childOrderContainerId).length && this.childOrderContainerId.childUuid) {
        return 0
      } else {
        const childrenOrders = this.containerOrders?.childrenOrderContainers?.items?.[0]?.orders || []
        const hasUnpaidOrders = childrenOrders.length > 0 && childrenOrders.some((order) => order.paymentStatus === 'UNPAID')

        if (hasUnpaidOrders) {
          return childrenOrders.reduce((acc, cur) => acc + cur.unpaidTotal, 0)
        }
        return 0
      }
    },
  },
  watch: {
    /**
     * @description 從外部讓他loading
     */
    propsLoading(nvl) {
      this.saveLoading = nvl
    },
    oldAndNewOrderComputed: {
      handler(nvl) {
        this.installmentForm.total = nvl
      },
      immediate: true,
    },
  },
  created() {
    // 訪客無法進入分期付款
    if (this.guestCheck) {
      this.paymentType = 'fullPayment'
    }
    // 從未付款訂單進來付款的狀態
    if (this.orderPaying) {
      this.installmentOrder.installments = this.containerOrders.installments
      this.installmentOrder.uuid = this.containerId || this.orderContainerUuid
      this.paymentType = 'installment'
      this.paymentMethodOnView = 'installment'
      this.installmentTableVisible = true
    }
    // 從子訂單付款不能分期
    if (this.childOrderPayment) {
      this.paymentType = 'fullPayment'
      this.paymentMethodOnView = ''
      this.installmentTableVisible = false
    }
  },
  mounted() {
    // console.log(this.$cashFlowSettingPass())
    // console.log('子容器與母容器未付款 以及 母子容器所屬childInvoiceStatus', this.childOrderContainerId)
  },
  methods: {
    /**
     * @description 選擇付款方式
     */
    paymentTypeFunc: debounce(function(type) {
      this.paymentType = type
    }, 500),
    /**
     * @description 選擇付款方式
     */
    paymentFunc: debounce(function(status) {
      // 如果是在沒有orderContainer狀況下走這邊 -> 必定是看選到的服務
      if (Object.keys(this.containerOrders).length === 0 && status === 'deposit') {
        const { canPayByDeposit } = this.newOrderInfo
        if (!canPayByDeposit) {
          this.depositDialog = true // 儲值點數抵扣未開放參數
          return
        } else {
          this.methodDepositWindow() // 儲值金走其他流程
          return
        }
      }

      // 已經有container -> 要去判斷是否有新訂單
      if (Object.keys(this.containerOrders).length > 0 && status === 'deposit') {
        const { childCanPayByDeposit, parentCanPayByDeposit } = this.childOrderContainerId
        const { canPayByDeposit: orderCanPayByDeposit } = this.newOrderInfo
        if (status === 'deposit' && (!childCanPayByDeposit || !parentCanPayByDeposit || !orderCanPayByDeposit)) {
          // console.log('開啟點數')
          this.depositDialog = true // 儲值點數抵扣未開放參數
          return
        }
        // 是儲職金 + 可以被儲值金抵扣的走這邊
        if (status === 'deposit' && (childCanPayByDeposit && parentCanPayByDeposit && orderCanPayByDeposit)) {
          // console.log('直接儲存')
          this.methodDepositWindow() // 儲值金走其他流程
          return
        }
      }
      this.paymentStatus = status
    }, 500),
    /**
     * @description 返回按鈕要返回去哪裡
     */
    backFunc() {
      if (this.paymentStatus === 'offLine' && this.paymentMethodOnView === '') {
        this.paymentStatus = ''
      }
      if (this.paymentStatus === 'offLine' && this.paymentMethodOnView !== '') {
        this.paymentMethodOnView = ''
      }
      if (this.paymentStatus === 'onLine' && this.paymentMethodOnView !== '') {
        this.paymentMethodOnView = ''
      }
      this.$emit('goBack')
    },
    /**
     * @description 付款方式種類
     */
    async paymentMethodFunc(method) {
      await this.validateMethodAndMoney(method)
      this.paymentMethodOnView = method
      this.paymentMethodForSave = method
    },
    /**
     * @description 驗證付款方法與價錢
     */
    validateMethodAndMoney(method) {
      return new Promise((resolve, reject) => {
        if (this.oldAndNewOrderComputed > 50000 && method === 'Vacc') {
          this.$message.error('虛擬帳戶訂單總計不得超過50000元')
          reject(new Error('虛擬帳戶訂單總計不得超過50000元'))
        } else {
          resolve()
        }
      })
    },
    /**
     * @description 確認付款按鈕
     */
    onClickSubmit: debounce(async function(type) {
      try {
        if (this.allPageLoading || this.saveLoading) return
        this.btnDisabled = true
        this.payListStop = false
        // 如果要付款了然後也需要開發票，就開窗
        if (type === 'PAID' && this.invoiceShow && this.oldAndNewOrderComputed > 0) {
          await this.openBillDialog()
        }
        // 若有新訂單，先新增一筆新訂單
        if (this.haveNewOrder > 0) {
          this.$emit('storeSingleOrder', () => {
            this.saveLoading = true
            this.tryToSaveOrder(this.oldAndNewOrderComputed, type)
          })
        } else {
          // 沒有新訂單，則直接儲存
          this.saveLoading = true
          await this.tryToSaveOrder(this.oldAndNewOrderComputed, type)
        }
      } catch (error) {
        this.saveLoading = false
        this.btnDisabled = false
        console.error(error.message)
      }
    }, 250),
    /**
     * @description 開啟發票視窗，然後資料回來後再把資料存起來
     */
    async openBillDialog() {
      return new Promise((resolve, reject) => {
        this.btnCheckResolveFunc = (item) => {
          if (item.CarrierType === '2') {
            item.CarrierNum = this.payPersonInfo['phoneNumber']
          }
          this.btnBillCheckSubmitData = item
          resolve()
        }
        this.btnCheckRejectFunc = () => {
          this.saveLoading = false
          this.btnBillCheckSubmitData = {}
          reject()
        }
        this.$emit('showSignDialogFromPayList', this.btnCheckResolveFunc, this.btnCheckRejectFunc)
      })
    },
    /**
     * @description 取消回上一步
     */
    onClickCancel() {
      this.paymentMethodOnView = ''
      this.paymentStatus = ''
    },
    setContainerId() {
      try {
        // for母訂單尚未付款
        if (this.orderContainerUuid.length > 0 && !this.containerId) {
          this.containerId = this.orderContainerUuid
        }
      } catch (error) {
        this.allPageLoading = false
        console.error(error.message)
      }
    },
    async tryToSaveChildOrder(total, type) {
      try {
        let unpaidTotal = 0
        const { childrenOrderContainers } = this.containerOrders
        if (childrenOrderContainers.items.find((childOrderContainer) => childOrderContainer.paymentStatus === 'UNPAID')) {
          const index = childrenOrderContainers.items.findIndex((childOrderContainer) => childOrderContainer.paymentStatus === 'UNPAID')
          this.containerId = childrenOrderContainers.items[index].uuid
          unpaidTotal = childrenOrderContainers.items[index].orders.reduce((acc, cur) => acc + cur.unpaidTotal, 0)
        } else {
          this.containerId = this.childOrderContainerId.childUuid
        }
        await this.storeApi(unpaidTotal ?? total, type)
      } catch (error) {
        this.allPageLoading = false
        this.btnDisabled = false
        console.error(error.message)
      }
    },
    /**
     * @description 儲值訂單
     */
    async tryToSaveOrder(total, type) {
      try {
        const hasChildrenOrders = this.childOrderContainerId?.childUuid?.length > 0
        const hasUnpaidChildrenOrders = this.containerOrders.childrenOrderContainers?.items?.some((childOrderContainer) => childOrderContainer.paymentStatus === 'UNPAID')

        // 子訂單付款
        if (hasChildrenOrders || hasUnpaidChildrenOrders) {
          await this.tryToSaveChildOrder(total, type)
        } else {
          // 母訂單付款
          this.setContainerId()
          await this.storeApi(total, type)
        }
      } catch (error) {
        this.btnDisabled = false
        this.allPageLoading = false
        this.saveLoading = false
        console.error(error.message)
      }
    },
    /**
     * @description 真正儲存打api的地方
     */
    async storeApi(total, type) {
      try {
        const { paymentMethod, paymentStatus } = this.decideMethodAndStatus(type)
        const payInfo = this.guestCheck ? this.guestPayInfo : this.payPersonInfo
        const shippingInfo = Object.keys(this.containerOrders).length && this.containerOrders ? this.containerOrders.shippingInfo : this.shippingInfo
        let data = {
          uuid: this.containerId,
          paymentMethod,
          paymentStatus,
          allowExpired: this.afterPay ? 1 : 0,
          total,
          ...payInfo, // 個資
          shippingInfo: shippingInfo,
          ...this.btnBillCheckSubmitData, // 發票資訊
        }

        if (paymentMethod === 'Installment') data.installments = this.installmentForm.installmentAmount

        this.moreSaveInfo(data)
        const result = await this.$store.dispatch('order/storeContainerId', data)
        if (result.code === 200) {
          this.saveLoading = false
          this.$message({
            type: 'success',
            message: '儲存成功',
          })
          // 不是分期付款直接關窗
          if (paymentMethod !== 'Installment') {
            this.$emit('checkOutSuccess')
          } else {
            // 取得分期付款資料，並打開付款表單
            this.installmentLoading = true
            await this.$store
              .dispatch('order/fetchContainerList', this.containerId || this.orderContainerUuid)
              .then((res) => {
                this.installmentOrder.installments = res.installments
                this.installmentOrder.uuid = this.containerId || this.orderContainerUuid
                this.paymentMethodOnView = 'installment'
                this.installmentTableVisible = true
              })
              .catch((err) => {
                console.error(err)
                this.$message.error('付款失敗')
              })
          }
        }
      } catch (error) {
        this.allPageLoading = false
        this.saveLoading = false
        await this.$alert(`付款錯誤，將跳出視窗`, {
          confirmButtonText: '確定',
          type: 'warning',
          center: true,
        })
        this.$emit('close')
        console.error(error.message)
      } finally {
        this.btnDisabled = false
        this.installmentLoading = false
      }
    },
    /**
     * @description 更多儲存資訊
     */
    moreSaveInfo(data) {
      try {
        if (this.paymentMethodOnView === 'Vacc') {
          data['bankType'] = this.submitData['bankType']
        }
        if (this.paymentMethodOnView === 'StoreCredit') {
          data['Card4No'] = this.submitData['Card4No']
        }
        if (this.paymentMethodOnView === 'Atm') {
          data['PayerAccount5Code'] = this.submitData['PayerAccount5Code']
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 決定付款方式與狀態
     */
    decideMethodAndStatus(type) {
      if (this.paymentMethodForSave === 'none') {
        return {
          paymentMethod: '',
          paymentStatus: 'UNPAID',
        }
      } else if (this.paymentType === 'installment') {
        return {
          paymentMethod: 'Installment',
          paymentStatus: type,
        }
      } else {
        return {
          paymentMethod: this.paymentMethodForSave,
          paymentStatus: type,
        }
      }
    },
    /**
     * @description 關閉儲值點數 & 儲值點數抵扣視窗
     */
    closeDepositNotOk() {
      this.depositDialog = false
    },
    /**
     * @description 開啟點數不足視窗
     */
    methodDepositWindow() {
      try {
        this.paymentMethodForSave = 'Deposit'
        this.$emit('paymentMethodDeposit', this.oldAndNewOrderComputed, () => {
          this.allPageLoading = true
          this.tryToSaveOrder(this.oldAndNewOrderComputed, 'PAID')
        })
        this.depositDialog = false
      } catch (error) {
        this.allPageLoading = false
        console.error(error.message)
      }
    },
    async installmentStatusManage(command) {
      switch (command) {
        // 回到最上層，並初始化表單
        case 'back':
          if (!this.assignAmountVisible) this.paymentType = ''
          this.assignAmountVisible = false
          this.installmentForm = {
            total: this.oldAndNewOrderComputed,
            installments: 2,
            installmentAmount: [],
          }
          break
        // 分配各期付款金額
        case 'assign':
          if (this.installmentForm.installments > 12) {
            this.$message.error('分期數不得大於12期')
            this.installmentForm.installments = 12
            return
          }
          if (this.installmentForm.installments < 2 || !this.installmentForm.installments) {
            this.$message.error('分期數不得小於2期')
            this.installmentForm.installments = 2
            return
          }
          this.assignAmountVisible = true
          this.installmentForm.installmentAmount = Array.from({ length: this.installmentForm.installments }, () => 0)
          break
        // 儲存訂單
        case 'store':
          const result = this.installmentForm.installmentAmount.some((item) => item === 0 || Number.isNaN(item))
          if (result) {
            this.$message.error('付款金額不得為0或空')
            return
          }
          await this.onClickSubmit('UNPAID')
          break
      }
    },
    handleInput(index, value) {
      // 判斷要驗證的input
      const indexNum = parseInt(index)
      let num = parseInt(value, 10)
      // input值不能為負
      num = num < 0 ? 0 : num

      if (isNaN(indexNum)) {
        this.$set(this.installmentForm, 'installments', num)
      } else {
        this.$set(this.installmentForm.installmentAmount, index, num)
      }
    },
    closeDialogAndDrawer() {
      this.$emit('checkOutSuccess')
    },
  },
}
</script>

<style lang="scss" module>
.payList {
  :global {
    .strokeFull {
      :global {
        g {
          stroke: $color-primary;
        }
      }
    }

    .fillFull {
      :global {
        g {
          fill: $color-primary;
        }
      }
    }

    .colorSecondary {
      color: $color-secondary;
    }

    .colorPrimary {
      color: $color-primary;
    }

    .colorTextLight {
      color: $color-text-light;
    }

    .f16 {
      font-size: 16px;
    }

    .mb4 {
      margin-bottom: 4px;
    }

    .mb8 {
      margin-bottom: 8px;
    }

    .tCenter {
      text-align: center !important;
    }
  }

  padding: 20px 30px;

  &__paymentAll {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  &__paymentList {
    &__upper {
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;

      > div {
        width: 300px;
        height: 246px;
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px solid $color-line-dark;
        border-radius: $border-radius;

        p:nth-child(2) {
          width: 200px;
          text-align: center;
          line-height: 26px;
        }
      }

      > div:nth-child(1) {
        margin-right: 20px;
      }
    }

    &__lower {
      display: flex;
      width: 620px;
      height: 246px;
      justify-content: center;
      align-items: center;
      background-color: white;
      margin-bottom: 14px;
      flex-direction: column;
      border: 1px solid $color-line-dark;
      border-radius: $border-radius;

      &__icon {
        border-radius: 50%;
        border: 2px solid $color-primary;
        width: 94px;
        height: 94px;
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
          font-size: 25px;
          color: $color-primary;
          border: 2px solid $color-primary;
          border-radius: 50%;
          padding: 20px;
        }
      }
    }

    &__iconBorder {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 94px;
      height: 94px;
      border-radius: 50%;
      border: 2px solid $color-primary;

      > svg {
        font-size: 60px;
        color: $color-primary;
      }
    }
  }

  &__orderTotal {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;
  }

  &__checkbox {
    display: flex;
    justify-content: flex-start;
    width: 620px;
  }

  &__offLine {
    &__upper {
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;

      > div {
        width: 300px;
        height: 246px;
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px solid $color-line-dark;
        border-radius: $border-radius;

        p:nth-child(2) {
          width: 200px;
          text-align: center;
          line-height: 26px;
        }
      }

      > div:nth-child(1) {
        margin-right: 20px;
      }
    }

    &__lower {
      display: flex;
      width: 620px;
      height: 246px;
      justify-content: center;
      align-items: center;
      background-color: white;
      margin-bottom: 14px;
      flex-direction: column;
      border: 1px solid $color-line-dark;
      border-radius: $border-radius;

      &__icon {
        border-radius: 50%;
        border: 2px solid $color-primary;
        width: 94px;
        height: 94px;
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
          font-size: 25px;
          color: $color-primary;
          border: 2px solid $color-primary;
          border-radius: 50%;
          padding: 20px;
        }
      }
    }

    &__iconBorder {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 94px;
      height: 94px;
      border-radius: 50%;
      border: 2px solid $color-primary;
      position: relative;
      z-index: 5;

      img {
        position: absolute;
        z-index: -1;
      }

      > svg {
        font-size: 60px;
        color: $color-primary;

        & > path {
          stroke: $color-primary;
        }
      }
    }
  }

  &__onLine {
    &__upper {
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;

      > div {
        width: 300px;
        height: 246px;
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px solid $color-line-dark;
        border-radius: $border-radius;

        p:nth-child(2) {
          width: 200px;
          text-align: center;
          line-height: 26px;
        }
      }

      > div:nth-child(1) {
        margin-right: 20px;
      }
    }

    &__iconBorder {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 94px;
      height: 94px;
      border-radius: 50%;
      border: 2px solid $color-primary;

      > svg {
        font-size: 60px;
        color: $color-primary;

        & > path {
          fill: $color-primary;
        }
      }
    }
  }

  &__installment {
    width: 50%;
    padding: 36px;

    &__form {
      padding: 18px 36px;
      background-color: #fff;
      border-radius: 4px;

      input[type='number']::-webkit-inner-spin-button,
      input[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }

    &__times {
      border-bottom: 0.5px solid $color-primary;

      span {
        margin-bottom: 4px;
      }
    }

    &__amount {
      border-bottom: 0.5px solid $color-primary;
    }
  }

  &__installment__table {
    width: 50%;
    padding: 36px;
    background-color: #fff;
    border-radius: 4px;
  }
}

.paymentMethodClass {
  width: 550px;
  height: 320px;
  background-color: white;
  padding-left: 45px;
  padding-right: 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  :global {
    .el-form {
      width: 100%;
    }

    .el-form-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .el-form-item__label {
      margin-bottom: 30px;
      text-align: center;
    }
  }
}

.paymentOnLineMethodClass {
  width: 550px;
  height: 320px;
  background-color: white;
  padding-left: 45px;
  padding-right: 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  :global {
    .el-form {
      width: 100%;
    }

    .el-form-item {
      display: flex;
      flex-direction: column;
    }

    .el-form-item__label {
      margin-bottom: 30px;
      text-align: left;
      margin-bottom: 0;
    }
  }
}

.dialogText {
  display: flex;
  justify-content: center;

  > p {
    text-align: center;
  }
}

.dialogCheckOk {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  > svg {
    font-size: 32px;
    color: #33c493;
  }

  > p {
    font-size: 24px;
  }
}

.header {
  :global {
    .el-page-header {
      align-items: center;
      font-size: 22px;
    }

    .el-page-header__left {
      border: 1px solid $color-border-for-bg-white;
      border-radius: $border-radius;
      padding: 12px 24px;
      background-color: white;
    }
  }
}

.fullWidth {
  :global {
    .el-table__header {
      width: 100% !important;
    }

    .el-table__empty-block {
      width: 100% !important;
    }

    .el-table__body {
      width: 100% !important;
    }
  }
}

.detailTable {
  &::before {
    height: 0;
    display: none;
  }

  :global {
    .goods-img {
      width: 100%;
    }

    .goods-info {
      p {
        margin: 0;
      }
    }

    .goods-amount {
      max-width: 100px;
    }

    .el-table__row {
      background-color: #ffffff;
    }

    .el-table__header-wrapper {
      th {
        background-color: #e5e7eb;
      }
      tr th .cell {
        display: flex;
        justify-content: center;
      }
      tr th .cell {
        justify-content: start;
      }
    }

    .el-table__footer-wrapper {
      tr td {
        background-color: #ffffff !important;
      }
      tr td:nth-child(3) .cell {
        text-align: center;
      }
    }

    th {
      border: none !important;
    }

    .close-icon {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
